import React from 'react';
import { Box } from '@tanium/react-box';
import { ColorStyleProps } from '@tanium/style-system';
import { ThemeSpace } from '@tanium/theme-data';
import { SelectedCountsFill } from './themeDefinitions';

interface Props {
  /**
   * The background to use for the well. Defaults to `ThemeColors.PrimaryButtonText`, which is
   * appropriate when the component is used inside a standard well.
   */
  bg?: ColorStyleProps['bg'];
  /**
   * Content to render in the well.
   */
  children?: React.ReactNode;
}

/**
 * A Well used to contain the count(s) and action(s) for selected items within a Results Header.
 */
export const ResultsCountsSelectedWell = ({ bg = SelectedCountsFill, children }: Props) => (
  <Box bg={bg} borderRadius={1} px={ThemeSpace.minor[3]} py={ThemeSpace.minor[1]}>
    {children}
  </Box>
);
